import { render, staticRenderFns } from "./dataCollection.vue?vue&type=template&id=1328e0ae&scoped=true&"
import script from "./dataCollection.vue?vue&type=script&lang=js&"
export * from "./dataCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328e0ae",
  null
  
)

export default component.exports